import { createContext, useContext, useState, useCallback } from "react";
import API from "@/lib/api";
import { useAuth } from "./AuthContext";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [cart, setCart] = useState({ items: [] });
  const { user } = useAuth();

  const fetchCart = useCallback(async () => {
    if (!user) { setCart({ items: [] }); return; }
    try {
      const { data } = await API.get("/cart");
      setCart(data);
    } catch { setCart({ items: [] }); }
  }, [user]);

  const addToCart = async (product_id, variant, quantity) => {
    const { data } = await API.post("/cart/add", { product_id, variant, quantity });
    setCart(data);
    return data;
  };

  const removeFromCart = async (item_id) => {
    const { data } = await API.delete(`/cart/remove/${item_id}`);
    setCart(data);
  };

  const updateQuantity = async (item_id, quantity) => {
    const { data } = await API.put(`/cart/update/${item_id}`, { quantity });
    setCart(data);
  };

  const cartCount = cart.items?.reduce((acc, i) => acc + (i.quantity || 0), 0) || 0;

  return (
    <CartContext.Provider value={{ cart, cartCount, fetchCart, addToCart, removeFromCart, updateQuantity }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
